import trkl from 'trkl';

class ConfigStore {
    // self
    modules = trkl([]);
    localization = trkl({});
    userProfile = trkl({});
    domainActions = trkl([]);

    // context
    currentAppKey = trkl('extranet');
    organigrammaServerUrl = trkl('');
    cdnConfiguration = trkl({});
    navigateFunction = (url) => window.location = url;
    manuals = trkl([]);
    helpdeskUrl = trkl('');
    homepageUrl = trkl('');
    iconBaseUrl = trkl('https://cdn.digitalpa.it/dpa-icons/v1');

    // authentication
    jwt = trkl('');
    refreshToken = trkl('');
    logoutRedirectUrl = trkl('');
    logoutCallback = () => {};
    authFailureCallback = () => {};

    // localization
    currentLanguage = trkl('it');
    availableLanguages = trkl(['it', 'en', 'es']);
    setCurrentLanguage = () => {};
}

const ConfigService = new ConfigStore();
export default ConfigService;



// WEBPACK FOOTER //
// ./services/ConfigService.js